"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const calculator_service_1 = require("./calculator.service");
const clickdimensions_service_1 = require("./clickdimensions.service");
const data_service_1 = require("./data.service");
const output_service_1 = require("./output.service");
const translate_service_1 = require("./translate.service");
var State;
(function (State) {
    State["Form"] = "form";
    State["Contact"] = "contact";
    State["Results"] = "results";
})(State || (State = {}));
class FleetSavings {
    constructor() {
        this.state = State.Form;
        // Default values that can be pulled in from url
        this.country = 'US';
        this.currencyCode = 'USD';
        this.savings = {
            idle: 100,
            optimization: 100,
            driverBehavior: 100,
            total: 300,
            carbon: 1000,
        };
        this.inputs = {
            country: null,
            fleetSize: null,
            estimatedDistance: null,
            fuelEfficiency: null,
            workDays: null,
            workDaysSlider: null,
            idleTime: null,
            fuelCostInput: null,
            fleetButton: null,
        };
        this.contactInputs = {
            first: null,
            last: null,
            email: null,
            phone: null,
            company: null,
            job: null,
            country2: null,
            referral: null,
            fleetSize: null,
            button: null,
        };
        this.translatableContent = [];
        this.dataService = new data_service_1.DataService();
        this.translateService = new translate_service_1.TranslateService();
        this.calculatorService = new calculator_service_1.CalculatorService();
    }
    async init() {
        try {
            await this.dataService.loadData();
        }
        catch (error) {
            console.error('Unable to load data', error);
        }
        // Load all translatable items
        document.querySelectorAll('[data-i18n]').forEach((element) => {
            this.translatableContent.push({
                key: element.textContent.trim(),
                element: element,
            });
        });
        this.setupFleetForm();
        this.setupContactForm();
        this.setupResultsPage();
        const params = this.parseQueryParams();
        this.setCountry(params.countryCode);
        this.inputs.country.value = params.countryCode; // not setting in set country because of duplicate loop
        this.setLang(params.lang);
        this.setDefaultValues();
        this.updateDisplay();
    }
    setupFleetForm() {
        this.inputs.country = this.getInput('#country');
        this.inputs.fleetSize = this.getInput('#fleet-size');
        this.inputs.estimatedDistance = this.getInput('#estimated-distance');
        this.inputs.fuelEfficiency = this.getInput('#fuel-efficiency');
        this.inputs.workDays = this.getInput('#work-days');
        this.inputs.workDaysSlider = this.getInput('#work-days-slider');
        this.inputs.idleTime = this.getInput('#idle-time');
        this.inputs.fuelCostInput = this.getInput('#fuel-cost');
        this.inputs.fleetButton = this.getInput('#fcc-calculator button');
        this.inputs.workDays.addEventListener('input', () => {
            this.inputs.workDaysSlider.value = this.inputs.workDays.value;
        });
        this.inputs.workDaysSlider.addEventListener('input', () => {
            this.inputs.workDays.value = this.inputs.workDaysSlider.value;
        });
        this.inputs.country.addEventListener('change', () => {
            this.setCountry(this.inputs.country.value);
            this.setDefaultValues();
            this.updateDisplay();
        });
        this.inputs.fleetButton.addEventListener('click', () => {
            this.show(State.Contact);
        });
    }
    setupContactForm() {
        const contactForm = document.getElementById('fcc-contact');
        contactForm.addEventListener('submit', (event) => {
            event.preventDefault();
        });
        this.contactInputs.first = this.getInput('#first');
        this.contactInputs.last = this.getInput('#last');
        this.contactInputs.email = this.getInput('#email');
        this.contactInputs.phone = this.getInput('#phone');
        this.contactInputs.company = this.getInput('#company');
        this.contactInputs.job = this.getInput('#job');
        this.contactInputs.country2 = this.getInput('#country2');
        this.contactInputs.referral = this.getInput('#referral');
        this.contactInputs.fleetSize = this.getInput('#fleetSize');
        this.contactInputs.button = this.getInput('#fcc-contact button');
    }
    setupResultsPage() {
        const downloadButton = document.getElementById('fcc-download');
        downloadButton.addEventListener('click', () => {
            output_service_1.OutputService.download('#fcc-results', 868, 748, 'Fleet Savings.pdf');
        });
    }
    parseQueryParams() {
        const params = new URLSearchParams(window.location.search);
        let countryCode = params.get('country');
        if (!countryCode) {
            countryCode = 'US';
        }
        else if (!this.dataService.isValidCountry(countryCode)) {
            console.error('Invalid country code', countryCode);
            countryCode = 'US';
            console.log('Expecting', this.dataService.countries.map((c) => c.value));
        }
        let lang = params.get('lang');
        if (!lang) {
            // Fallback to country specific
            switch (countryCode) {
                case 'DK': {
                    lang = 'da';
                    break;
                }
                case 'DE': {
                    lang = 'de';
                    break;
                }
                case 'BR': {
                    lang = 'pt';
                    break;
                }
                case 'ES':
                case 'MX': {
                    lang = 'es';
                    break;
                }
                case 'BE':
                case 'NL': {
                    lang = 'du';
                    break;
                }
                case 'FR': {
                    lang = 'fr';
                    break;
                }
                case 'NO': {
                    lang = 'nn';
                    break;
                }
                case 'SE': {
                    lang = 'sv';
                    break;
                }
                default: {
                    lang = 'en';
                }
            }
        }
        return {
            countryCode: countryCode,
            lang: lang,
        };
    }
    setLang(lang) {
        this.translateService.setLang(lang);
    }
    setCountry(value) {
        this.country = value;
        let units = 'metric';
        if (this.country === 'US') {
            units = 'us';
        }
        else if (this.country === 'GB') {
            units = 'gb';
        }
        this.translateService.setUnits(units);
        this.currencyCode = this.dataService.getCurrencyCode(value);
        this.translateService.setToken('currencyCode', this.currencyCode);
    }
    setDefaultValues() {
        let estimatedDistance = 120;
        if (this.country !== 'US' && this.country !== 'GB') {
            estimatedDistance = Math.floor(estimatedDistance * calculator_service_1.KM_PER_MILE);
        }
        let fuelEfficiency = 7.8;
        if (this.country === 'GB') {
            // Miles/Gallon => Miles/Litre
            fuelEfficiency = parseFloat((fuelEfficiency * calculator_service_1.GALLON_PER_LITER).toFixed(1));
        }
        else if (this.country !== 'US') {
            // Miles/Gallon => KM / Liter
            fuelEfficiency = fuelEfficiency * calculator_service_1.KM_PER_MILE * calculator_service_1.GALLON_PER_LITER;
            // KM/Liter => Liter/100KM
            fuelEfficiency = parseFloat((100 / fuelEfficiency).toFixed(1));
        }
        this.setValues({
            country: this.country,
            fleetSize: 3,
            estimatedDistance: estimatedDistance,
            fuelEfficiency: fuelEfficiency,
            workDays: 5,
            idleTime: 3.0,
            fuelCost: this.dataService.getFuelCost(this.country),
        });
    }
    setValues(input) {
        this.setCountry(input.country);
        this.inputs.country.value = input.country;
        this.inputs.fleetSize.value = input.fleetSize;
        this.inputs.estimatedDistance.value = input.estimatedDistance;
        this.inputs.fuelEfficiency.value = input.fuelEfficiency;
        this.inputs.workDays.value = input.workDays;
        this.inputs.workDaysSlider.value = input.workDays;
        this.inputs.idleTime.value = input.idleTime;
        this.inputs.fuelCostInput.value = input.fuelCost;
    }
    getValues() {
        const values = {
            country: this.inputs.country.value,
            fleetSize: parseFloat(this.inputs.fleetSize.value),
            estimatedDistance: parseFloat(this.inputs.estimatedDistance.value),
            fuelEfficiency: parseFloat(this.inputs.fuelEfficiency.value),
            workDays: parseFloat(this.inputs.workDays.value),
            idleTime: parseFloat(this.inputs.idleTime.value),
            fuelCost: parseFloat(this.inputs.fuelCostInput.value),
        };
        return values;
    }
    getInput(selector) {
        return document.querySelector(selector);
    }
    show(state) {
        this.state = state;
        this.updateDisplay();
    }
    updateDisplay() {
        // Translations
        this.translatableContent.forEach((item) => {
            const translation = this.translateService.get(item.key);
            if (translation) {
                item.element.innerHTML = translation;
            }
        });
        // Update currency symbols
        const symbol = this.dataService.getCurrencySymbol(this.country);
        document.querySelectorAll('span.currency').forEach((element) => {
            element.innerHTML = symbol;
        });
        this.inputs.fuelCostInput.style.paddingLeft =
            symbol.length * 0.7 + 0.5 + 'em';
        // Update results
        if (this.state === State.Results || this.state === State.Contact) {
            // Calculate the results
            const values = this.getValues();
            const savings = this.calculatorService.getSavings(values, this.country);
            // Set the local to france to get euorpean number formatting
            const locale = this.currencyCode === 'EUR' ? 'fr' : 'en';
            const moneyFormatter = new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: this.currencyCode,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });
            const setMoney = (selector, value) => {
                const element = document.querySelector(selector);
                element.innerHTML = moneyFormatter.format(value);
            };
            setMoney('#result-idle', savings.idle);
            setMoney('#result-optimization', savings.optimization);
            setMoney('#result-driverBehavior', savings.driverBehavior);
            setMoney('#result-total', savings.total);
            setMoney('#preview-total', savings.total);
            const numberFormatter = new Intl.NumberFormat(locale, {
                style: 'decimal',
                currency: this.currencyCode,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });
            document.getElementById('result-carbon').innerHTML =
                numberFormatter.format(savings.carbon);
            const setValue = (selector, value) => {
                const element = document.querySelector(selector);
                element.innerHTML = value;
            };
            setValue('#result-country', this.translateService.get(`COUNTRY_${values.country}`));
            setValue('#result-fleet-size', values.fleetSize);
            setValue('#result-estimated-distance', values.estimatedDistance);
            setValue('#result-estimated-fuel-efficiency', values.fuelEfficiency);
            setValue('#result-work-days', values.workDays);
            setValue('#result-idle-time', values.idleTime);
            setValue('#result-fuel-cost', values.fuelCost);
            // We are passing fleet size along as a hidden field
            this.contactInputs.fleetSize.value = values.fleetSize;
        }
        // Containers
        const intro = document.getElementById('fcc-intro');
        const calculator = document.getElementById('fcc-calculator');
        const contact = document.getElementById('fcc-contact');
        const results = document.getElementById('fcc-results');
        if (this.state === State.Form) {
            intro.style.display = 'block';
            calculator.style.display = 'block';
            results.style.display = 'none';
            contact.style.display = 'none';
        }
        else if (this.state === State.Contact) {
            intro.style.display = 'none';
            calculator.style.display = 'none';
            results.style.display = 'none';
            contact.style.display = 'flex';
        }
        else if (this.state === State.Results) {
            intro.style.display = 'none';
            calculator.style.display = 'none';
            results.style.display = 'flex';
            contact.style.display = 'none';
        }
    }
}
document.addEventListener('DOMContentLoaded', function () {
    const app = new FleetSavings();
    app.init().then(() => {
        const cd = new clickdimensions_service_1.ClickDimensionsService({
            formId: 'fcc-contact',
            cdPageId: 'npnhrdifeeo6gaisdxhpg',
            debug: false,
            onError: (values) => {
                console.error('Error submitting form', values);
            },
            beforeSubmit: () => {
                console.log('Submitting form');
                if (window.localStorage) {
                    window.localStorage.setItem('fcc', JSON.stringify(app.getValues()));
                }
            },
            afterSubmit: () => {
                console.log('Submit Complete form');
                if (window.localStorage) {
                    try {
                        const values = JSON.parse(window.localStorage.getItem('fcc'));
                        app.setValues(values);
                        app.show(State.Results);
                    }
                    catch (e) {
                        console.error('Error loading values', e);
                    }
                }
            },
        });
    });
});
